import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * App-owned UI preferences that must survive a refresh. Persisted to
 * localStorage via zustand's `persist` middleware.
 *
 * Note: theme is deliberately NOT here — it lives in ThemeProvider so the
 * no-flash inline script in index.html can read it synchronously before any JS
 * bundle (including this store) loads. Everything else persists here.
 */
interface PreferencesState {
  /** Whether the dashboard sidebar is expanded. */
  sidebarOpen: boolean
  setSidebarOpen: (open: boolean) => void
}

export const usePreferences = create<PreferencesState>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
    }),
    {
      name: 'warike-preferences',
      version: 1,
    },
  ),
)
